import { rootApi } from '../rootApi';
import { cleanParams } from '../utils';

export const vehicleSaleApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getSaleListingList: builder.query({
            query: (filters = {}) => ({
                url: 'v1/VehicleSale/GetSaleListingList',
                method: 'GET',
                params: cleanParams({
                    chassisNo: filters.chassisNo,
                    brand: filters.brand,
                    model: filters.model,
                    sellerBranchCode: filters.sellerBranchCode,
                    onlyMine: filters.onlyMine,
                    status: filters.status,
                    pageNumber: filters.pageNumber,
                    pageSize: filters.pageSize,
                    languageId: filters.languageId
                })
            }),
            transformResponse: (res) => {
                if (!res?.isSuccessful || !res?.data) return { items: [], totalCount: 0 };
                return {
                    items: Array.isArray(res.data.items) ? res.data.items : [],
                    totalCount: res.data.totalCount ?? 0
                };
            },
            providesTags: ['VehicleSale', 'VehicleSaleListing']
        }),
        getSaleListingDetail: builder.query({
            query: ({ listingId, languageId } = {}) => ({
                url: 'v1/VehicleSale/GetSaleListingDetail',
                method: 'GET',
                params: cleanParams({ listingId, languageId })
            }),
            transformResponse: (res) => (res?.isSuccessful ? res.data : null),
            providesTags: (result, error, arg) => [{ type: 'VehicleSaleListing', id: arg?.listingId }]
        }),
        getMyPurchaseRequests: builder.query({
            query: (filters = {}) => ({
                url: 'v1/VehicleSale/GetMyPurchaseRequests',
                method: 'GET',
                params: cleanParams({
                    status: filters.status,
                    chassisNo: filters.chassisNo,
                    pageNumber: filters.pageNumber,
                    pageSize: filters.pageSize,
                    languageId: filters.languageId
                })
            }),
            transformResponse: (res) => {
                if (!res?.isSuccessful || !res?.data) return { items: [], totalCount: 0 };
                return {
                    items: Array.isArray(res.data.items) ? res.data.items : [],
                    totalCount: res.data.totalCount ?? 0
                };
            },
            providesTags: ['VehicleSale', 'VehicleSaleRequest']
        }),
        getDealerFilterOptions: builder.query({
            query: ({ languageId } = {}) => ({
                url: 'v1/VehicleSale/GetDealerFilterOptions',
                method: 'GET',
                params: cleanParams({ languageId })
            }),
            transformResponse: (res) => (res?.isSuccessful && Array.isArray(res?.data) ? res.data : [])
        }),
        createPurchaseRequest: builder.mutation({
            query: (body) => ({
                url: 'v1/VehicleSale/CreatePurchaseRequest',
                method: 'POST',
                body
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['VehicleSale', 'VehicleSaleListing', 'VehicleSaleRequest']
        }),
        cancelPurchaseRequest: builder.mutation({
            query: (body) => ({
                url: 'v1/VehicleSale/CancelPurchaseRequest',
                method: 'POST',
                body
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['VehicleSale', 'VehicleSaleListing', 'VehicleSaleRequest']
        }),
        processPurchaseRequest: builder.mutation({
            query: (body) => ({
                url: 'v1/VehicleSale/ProcessPurchaseRequest',
                method: 'POST',
                body
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['VehicleSale', 'VehicleSaleListing', 'VehicleSaleRequest']
        })
    })
});

export const {
    useGetSaleListingListQuery,
    useLazyGetSaleListingListQuery,
    useGetSaleListingDetailQuery,
    useLazyGetSaleListingDetailQuery,
    useGetMyPurchaseRequestsQuery,
    useLazyGetMyPurchaseRequestsQuery,
    useGetDealerFilterOptionsQuery,
    useCreatePurchaseRequestMutation,
    useCancelPurchaseRequestMutation,
    useProcessPurchaseRequestMutation
} = vehicleSaleApi;
